import ShimmerBanner from "./shimmers/ShimmerBanner";
import useGetImages from "../hooks/useGetImages";
import { useTheme } from "../context/ThemeContext";
import { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const BannerList = ({ category, id, language }) => {
  const theme = useTheme();
  const { image: uri, isLoading } = useGetImages(
    "category_pictures",
    id,
    category
  );

  const [previewOpen, setPreviewOpen] = useState(false);
  const openPreview = () => setPreviewOpen(true);
  const closePreview = () => setPreviewOpen(false);

  if (!category) {
    return null;
  }

  return (
    <div className="container">
      {isLoading ? (
        <div className="flex gap-4 md:gap-8 mb-2">
          {Array.from({ length: 1 }).map((_, i) => (
            <ShimmerBanner key={i} />
          ))}
        </div>
      ) : uri ? (
        <div className="flex flex-col justify-center items-center">
          <img
            className="block h-[135px] w-[240px] rounded-md object-cover cursor-zoom-in"
            src={uri}
            alt="Images"
            onClick={openPreview}
          />
          <h1 className="font-bold text-xl text-zinc-600 text-center my-2">
            {category}
          </h1>
        </div>
      ) : (
        <div className="flex flex-col justify-center items-center mb-4">
          <h1 className={`font-bold text-xl ${theme.primary.text} text-center py-3 px-6 ${theme.primary.bgLight} rounded-md`}>
            {category}
          </h1>
        </div>
      )}
      <Modal isOpen={previewOpen} toggle={closePreview} centered size="lg">
        <ModalHeader toggle={closePreview}>{category}</ModalHeader>
        <ModalBody className="flex justify-center items-center bg-black/80">
          <img
            src={uri}
            alt={category}
            style={{ maxWidth: "100%", maxHeight: "80vh", objectFit: "contain" }}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={closePreview}>Geri</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};
export default BannerList;
